module.exports = __webpack_public_path__ + "img/pic_2@2x.8fa070cf.jpg";